import Glide from '@glidejs/glide';

const initBlockSlider = () => {
    let blocks = document.querySelectorAll('.js-block-slider');
    if (!blocks) return;
    if (blocks.length < 1) return;

    let init = (block) => {
        let gliderRoot = block.querySelector('.glide');
        if (!gliderRoot) return;

        const items = block.querySelectorAll('.glide__slide').length;

        let options = {
            type: 'carousel',
            perView: 1,
            bound: 0,
            autoplay: parseInt(block.dataset.autoplay) ?? 0,
            animationDuration: 900,
            pauseOnHover: true,
            swipeThreshold: 40, //default 80, which is a bit too lazy
            dragThreshold: 60, //default 120, which is a bit too lazy
            touchAngle: 30,
            peek: { before: 0, after: 0 },
            gap: 20,
        };

        const glide = new Glide(gliderRoot, options);

        const resize = () => {
            if (items <= glide.settings.perView) {
                glide.pause();
                glide.disable();
                block.classList.add('is-disabled');
                return;
            }

            glide.play();
            glide.enable();
            block.classList.remove('is-disabled');
        };

        glide.on('resize', function () {
            resize();
        });

        glide.on('mount.after', function () {
            gliderRoot.classList.add('mounted');
        });

        let left = block.querySelector('.js-left');
        let right = block.querySelector('.js-right');
        if (left) {
            left.addEventListener('click', () => {
                glide.go('<');
            });
        }
        if (right) {
            right.addEventListener('click', () => {
                glide.go('>');
            });
        }

        glide.mount();
        resize();
    };

    blocks.forEach((block) => {
        init(block);
    });
};

export {initBlockSlider};
